const filtersDef = {
    sellType: [
        {checked: true, label: 'VENTE'},
        {checked: true, label: 'LOCATION'}
    ],
    bienType: [],
    reference: '',
    city: '',
    chambresRange: [0, 0],
    chambresValues: [0, 0],
    surfaceRange: [0, 0],
    surfaceValues: [0, 0],
    prixRange: [0, 0],
    prixValues: [0, 0],
}

function filtersState(state = filtersDef, action) {
    switch (action.type) {
        case "SET_SELL_TYPE": {
            return {
                ...state,
                sellType: action.payload
            }
        }
        case "SET_BIEN_TYPE": {
            return {
                ...state,
                bienType: action.payload
            }
        }
        case "SET_REFERENCE": {
            return {
                ...state,
                reference: action.payload
            }
        }
        case "SET_CITY": {
            return {
                ...state,
                city: action.payload
            }
        }
        case "SET_CHAMBRES_RANGE": {
            return {
                ...state,
                chambresRange: action.payload
            }
        }
        case "SET_CHAMBRES_VALUES": {
            return {
                ...state,
                chambresValues: action.payload
            }
        }
        case "SET_SURFACE_RANGE": {
            return {
                ...state,
                surfaceRange: action.payload
            }
        }
        case "SET_SURFACE_VALUES": {
            return {
                ...state,
                surfaceValues: action.payload
            }
        }
        case "SET_PRIX_RANGE": {
            return {
                ...state,
                prixRange: action.payload
            }
        }
        case "SET_PRIX_VALUES": {
            return {
                ...state,
                prixValues: action.payload
            }
        }
        default:
            return state
    }
}
export default filtersState;
